import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  Input,
  Label,
  FormGroup,
  Form,
} from "reactstrap";

const ClientFilterModal = ({  setClientFilterModalOpen,
    clientFilterModalOpen }) => {
  const [formData, setFormData] = useState({
    name: "",
    incentiveType: "",
    videoTitle: "",
    videoLink: "",
    quota: "on",
    status: true,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
  };

  const closeModal = () => setClientFilterModalOpen(false);


  return (
    <Modal
    isOpen={clientFilterModalOpen}
    toggle={closeModal}
      backdrop="static"
      className="modal-dialog-right modal-full-height"
    >
      <ModalBody className="p-4" style={{ maxHeight: "95vh", overflowY: "auto" }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-bold mb-0">Job Category</h5>
          <Button close onClick={closeModal} />
        </div>
        <hr />

        <Form onSubmit={handleSubmit}>
          {/* Name */}
          <FormGroup>
            <Label>Name</Label>
            <Input
              type="text"
              name="name"
              placeholder="Type"
              value={formData.name}
              onChange={handleChange}
            />
          </FormGroup>

          {/* Incentive Type */}
          <FormGroup>
            <Label>Incentive Type</Label>
            <Input
              type="select"
              name="incentiveType"
              value={formData.incentiveType}
              onChange={handleChange}
            >
              <option value="">Select</option>
              <option value="bonus">Bonus</option>
              <option value="commission">Commission</option>
            </Input>
          </FormGroup>

          {/* Video Title */}
          <FormGroup>
            <Label>Video Title</Label>
            <Input
              type="text"
              name="videoTitle"
              placeholder="Type"
              value={formData.videoTitle}
              onChange={handleChange}
            />
          </FormGroup>

          {/* Video Link */}
          <FormGroup>
            <Label>Video Link</Label>
            <Input
              type="select"
              name="videoLink"
              value={formData.videoLink}
              onChange={handleChange}
            >
              <option value="">Select</option>
              <option value="youtube">YouTube</option>
              <option value="vimeo">Vimeo</option>
            </Input>
          </FormGroup>

          {/* Quota Field */}
          <FormGroup>
            <Label>Quota</Label>
            <div className="input-box d-flex align-items-center justify-content-between">
              <span className="text-muted">Type</span>
              <div>
                <Input
                  type="radio"
                  name="quota"
                  value="on"
                  checked={formData.quota === "on"}
                  onChange={handleChange}
                />{" "}
                On
                <Input
                  type="radio"
                  name="quota"
                  value="off"
                  checked={formData.quota === "off"}
                  onChange={handleChange}
                  className="ms-3"
                />{" "}
                Off
              </div>
            </div>
          </FormGroup>

          {/* Status Field */}
          <FormGroup>
            <Label>Status</Label>
            <div className="input-box d-flex align-items-center justify-content-between">
              <span className="text-muted">Type</span>
              <div className="d-flex align-items-center">
                <strong className="me-2">
                  {formData.status ? "Active" : "Inactive"}
                </strong>
                <div className="form-switch">
                  <Input
                    type="switch"
                    name="status"
                    checked={formData.status}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </FormGroup>

          <div className="text-end mt-3">
            <Button color="primary" type="submit">
              Save
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default ClientFilterModal;
